import Vue from 'vue'
import Router from 'vue-router'
import ElecnotesUpload from '@/components/elecnotes/upload'
import ElecnotesUploadFile from '@/components/elecnotes/upload-file'
import UploadFileTx from '@/components/elecnotes/upload-file-tx'
import UploadTx from '@/components/elecnotes/upload-tx'
import ElecnotesManage from '@/components/elecnotes/manage'
import ConsultEdit from '@/components/consult/consult-edit'
import ConsultManage from '@/components/consult/manage'
import ConsultSharedEdit from '@/components/consult-shared/shared-edit'
import ConsultSharedManage from '@/components/consult-shared/manage'
import InvoiceManage from '@/components/invoice/manage';
import InvoiceEdit from '@/components/invoice/invoice-edit'
import TransferManage from '@/components/transfer/manage';
import TransferEdit from '@/components/transfer/transfer-edit'
import Live from '@/components/live'
import Test from '@/components/test'
import Page404 from '@/components/404'
import ResourceDevelopment from '@/components/consult/resource-development'
import Publicity from '@/components/publicity/publicity'
import HrHome from '@/components/hr/home';
import Register from '@/components/hr/register';
import Index from '@/components/hr/index';
import Uppass from '@/components/hr/uppass';
import FundEmployeeAdd from '@/components/hr/fund/employee-add';
import FundEmployeeDel from '@/components/hr/fund/employee-del';
import SocialCommonAdd from '@/components/hr/social/common-add';
import FundDetail from '@/components/hr/fund/fund-detail'
import FundDetailPerson from '@/components/hr/fund/fund-detail-person'
import WxList from '@/components/hr/wxbill/list';
import WxListEmp from '@/components/hr/wxbill/list-emp';
import EmpList from '@/components/hr/employee/emp-list';
import PresidentMailboxList from '@/components/president-mailbox/list';
import ClientInServiceQuery from '@/components/client-in-service/query';
Vue.use(Router)

export const constantRoutes = [{
    path: '/elecnotes/upload',
    name: 'ElecnotesUpload',
    component: ElecnotesUpload,
    meta: {
      title: '选择客户'
    }
  },
  {
      path: '/elecnotes/UploadTx',
      name: 'UploadTx',
      component: UploadTx,
      meta: {
        title: '选择票据类型'
      }
    },

  {
    path: '/elecnotes/upload-file',
    name: 'ElecnotesUploadFile',
    component: ElecnotesUploadFile,
    meta: {
      title: '票据上传'
    }
  },
  {
    path: '/elecnotes/upload-file-tx',
    name: 'UploadFileTx',
    component: UploadFileTx,
    meta: {
      title: '票据上传'
    }
  },
  {
    path: '/elecnotes/manage',
    name: 'ElecnotesManage',
    component: ElecnotesManage,
    meta: {
      title: '票据管理'
    }
  },
  {
    path: '/consult/consult-edit',
    name: 'ConsultEdit',
    component: ConsultEdit,
    meta: {
      title: '编辑咨询'
    }
  },
  {
    path: '/consult/manage',
    name: 'ConsultManage',
    component: ConsultManage,
    meta: {
      title: '咨询管理'
    }
  },
  {
    path: '/consult-shared/shared-edit',
    name: 'ConsultSharedEdit',
    component: ConsultSharedEdit,
    meta: {
      title: '编辑资源共享'
    }
  },
  {
    path: '/consult-shared/manage',
    name: 'ConsultSharedManage',
    component: ConsultSharedManage,
    meta: {
      title: '资源共享管理'
    }
  },
  {   
    path:'/invoice/manage',
    name:'InvoiceManage',
    component:InvoiceManage,
    meta: {
      title: '客户开票管理'
    }
  },
  {   
    path:'/invoice/invoice-edit',
    name:'InvoiceEdit',
    component:InvoiceEdit,
    meta: {
      title: '编辑客户开票'
    }
  },
  {   
    path:'/transfer/manage',
    name:'TransferManage',
    component:TransferManage,
    meta: {
      title: '客户转账管理'
    }
  },
  {   
    path:'/transfer/transfer-edit',
    name:'TransferEdit',
    component:TransferEdit,
    meta: {
      title: '编辑客户转账'
    }
  },
  {
    path: '/live',
    name: 'Live',
    component: Live,
    meta: {
      title: '直播'
    }
  },
  {   path:'/consult/resource-development',
      name:'ResourceDevelopment',
      component:ResourceDevelopment
  },
  {   path:'/publicity/publicity',
      name:'Publicity',
      component:Publicity
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: {
      title: '测试'
    }
  },

{
    path: '/',
    name: 'HrHome',
    component: HrHome
    // children: [{
    //   path: 'register', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
    //   name: 'Register',
    //   component: Register
    // }]
  },

  {
    path: '/hr/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/hr/index',
    name: 'Index',
    component: Index
  },
  {
    path: '/fund/employee-add',
    name: 'FundEmployeeAdd',
    component: FundEmployeeAdd
  },
  {
    path: '/fund/employee-del',
    name: 'FundEmployeeDel',
    component: FundEmployeeDel
  },
  {
    path: '/social/common-add',
    name: 'SocialCommonAdd',
    component: SocialCommonAdd
  },
  {
    path: '/hr/home/up',
    name: 'Uppass',
    component: Uppass
  }, {
    path: '/hr/fund-detail',
    name: 'FundDetail',
    component: FundDetail
  }, {
    path: '/hr/fund-detail-person',
    name: 'FundDetailPerson',
    component: FundDetailPerson
  }, {
    path: '/hr/WxList',
    name: 'WxList',
    component: WxList
  }, {
    path: '/hr/WxListEmp',
    name: 'WxListEmp',
    component: WxListEmp
  }, {
    path: '/hr/EmpList',
    name: 'EmpList',
    component: EmpList
  }, {
    path: '/president-mailbox/list',
    name: 'PresidentMailboxList',
    component: PresidentMailboxList
  }, {
    path: '/client-in-service/query',
    name: 'ClientInServiceQuery',
    component: ClientInServiceQuery
  }, {
    path: '/404',
    component: Page404
  }
]

// 需要通过菜单权限判断的路由
export const asyncRoutes = [
  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()
export default router



// WEBPACK FOOTER //
// ./src/router/index.js